import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { API_END_POINTS } from '../constant/api.constant';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment';
import { FireBaseService } from './firebase.service';

declare let device: any;

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  private riskProfileSubject = new BehaviorSubject<any>(null);
  riskProfile = this.riskProfileSubject.asObservable();
  isApp: boolean = environment.app;
  referreeActv: string[] = ['referral_credits_rfy', 'risk_profile_update_rfy', 'free_pack_subscription_rfy', 'paid_pack_subscription_rfy', 'first_time_investment_rfy']
  referredActv: string[] = ['referral_credits_rfd', 'risk_profile_update_rfd', 'free_pack_subscription_rfd', 'paid_pack_subscription_rfd', 'first_time_investment_rfd']
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private firebaseService: FireBaseService,
  ) {
    this.alertService.getIsMobileDevice().subscribe((res: boolean) => {
      if (!environment.app) {
        this.isApp = res;
      }
    });
  }

  public dashboardAlert: EventEmitter<any> = new EventEmitter();
  public leaderboard: EventEmitter<any> = new EventEmitter();

  public MFordersSub = new BehaviorSubject<any>(null);
  mfOrders = this.MFordersSub.asObservable();

  public topAdvisors(callCat): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.CLIENTS.advisors}?callCategory=${callCat}&sortOnReturns=-1&page=1&limit=3`
    );
  }

  public adminDashboardAlert(): Observable<any> {
    return this.http.get(API_END_POINTS.NOTIFICATION.investorDashboardAlert);
  }

  public getRiskProfile(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR.risk_profile);
  }

  public followAdvisor(id: any) {
    return this.http.put(`${API_END_POINTS.INVESTOR.followAdvisor}/${id}`, {});
  }

  public getAdvisorAnalytics(category: any): Observable<any> {
    return this.http.get(
      `${API_END_POINTS.CLIENTS.advisorAnalytics}?callCategory=${category}`
    );
  }
  clientList(query: any) {
    return this.http.get(`${API_END_POINTS.CLIENTS.advisors}?${query}`);
  }

  public tourCompleted(): Observable<any> {
    const data = {
      isTourCompleted: true,
    };
    return this.http.put(`${API_END_POINTS.INVESTOR.users}`, data);
  }

  getProfileQuestions(): Observable<any> {
    return this.http.get(API_END_POINTS.INVESTOR.risk_profile_question);
  }

  submitRiskProfile(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR.risk_profile_question, data);
  }

  clientDetail(id: any) {
    return this.http.get(`${API_END_POINTS.CLIENTS.advisors}/${id}`);
  }

  clientReviews(id: any, query: any) {
    return this.http.get(
      `${API_END_POINTS.INVESTOR.clientReviews}/${id}?${query}`
    );
  }
  updateProfile(data: any) {
    return this.http.put(`${API_END_POINTS.INVESTOR.users}`, data);
  }

  getAllPredictions(): Observable<any> {
    return this.http.get(`${API_END_POINTS.PREDICTIONS.client}`);
  }

  clientPerformanceStatistics(id: any, query: any) {
    return this.http.get(
      `${API_END_POINTS.CLIENTS.performanceStatistics}/${id}?${query}`
    );
  }

  clientCallList(id: any, query: any) {
    return this.http.get(
      `${API_END_POINTS.INVESTOR.clientCalls}/${id}?${query}`
    );
  }

  getTopNews(query): Observable<any> {
    return this.http.get(`${API_END_POINTS.NEWS.news}?${query}`);
  }

  predictionDate(): Observable<any> {
    return this.http.get(API_END_POINTS.PREDICTIONS.predict_date);
  }

  adminAlert(): Observable<any> {
    return this.http.get(API_END_POINTS.ADVISOR.admin_alert);
  }

  getVideoPredictions(): Observable<any> {
    return this.http.get(`${API_END_POINTS.PREDICTIONS.video_predictions}`);
  }

  getCallByIdInvstr(type: any, id: any): Observable<any> {
    if (type === 'new') {
      return this.http.get(`${API_END_POINTS.INVESTOR.newCall}/${id}`);
    }
    if (type === 'closed') {
      return this.http.get(`${API_END_POINTS.INVESTOR.closedCall}/${id}`);
    }
    if (type === 'my') {
      return this.http.get(`${API_END_POINTS.INVESTOR.myCall}/${id}`);
    }
    if (type === 'watch') {
      return this.http.get(`${API_END_POINTS.INVESTOR.watchCall}/${id}`);
    }
  }

  getCallByIdAdv(type, id): Observable<any> {
    if (type === 'ongoing') {
      return this.http.get(
        `${API_END_POINTS.ADVISOR.dashboard}/ongoing/calls/${id}`
      );
    } else if (type === 'closed') {
      return this.http.get(
        `${API_END_POINTS.ADVISOR.dashboard}/history/calls/${id}`
      );
    }

  }
  getInstruments(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.ADVISOR.market_instrument}`, data);
  }
  getMarketWatch(): Observable<any> {
    return this.http.get(`${API_END_POINTS.MW.market_watch}`);
  }
  getMarketDepth(token: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.MW.market_watch}/${token}`);
  }
  addMarketWatch(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.MW.market_watch}`, data);
  }
  deleteMarketWatch(id: any): Observable<any> {
    return this.http.delete(`${API_END_POINTS.MW.market_watch}/${id}`);
  }

  setRiskProfile() {
    this.http.get(API_END_POINTS.INVESTOR.risk_profile).subscribe((res: any) => {
      this.riskProfileSubject.next(res.data);
    });
  }

  public recentVideos = (): Observable<any> => {
    return this.http.get(`${API_END_POINTS.VIDEOS.all_videos}?page=1&limit=5`);
  }

  recentDiscussed = (): Observable<any> => {
    return this.http.get(`${API_END_POINTS.DISCUSSION.most_discussed}?page=1&limit=2`);
  }
  getTopicByInstrument(token: any) {
    return this.http.get(`${API_END_POINTS.DISCUSSION.topicByInstrument}/${token}`);
  }

  piggyBankData(): Observable<any> {
    return this.http.get(API_END_POINTS.PIGGY_BANK.total_savings);
  }

  public addMoneyToWallet(data): Observable<any> {
    return this.http.post(API_END_POINTS.WALLET.addAmount, data);
  }

  getMFImages(): Observable<any> {
    return this.http.get(API_END_POINTS.MUTUALFUND.amc);
  }

  getCommunityPredictions(): Observable<any> {
    return this.http.get(`${API_END_POINTS.PREDICTIONS.community_views}`);
  }
  dashBoardSearch(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.INVESTOR_LONGTERM.dash_search}`, data);
  }

  sendApiEvents(eventName, type) {
    let data: any = {
      event: eventName,
      type
    }
    if (environment.app) {
      data.platform = 'android'
    }
    if (environment.app && environment.ios) {
      data.platform = 'ios'
    }
    if (!environment.app && !this.isApp) {
      data.platform = 'web'
    }

    if (!environment.app && this.isApp) {
      data.platform = 'mobile'
    }

    let deviceDetails: any;
    this.firebaseService.deviceDetail.subscribe((res) => deviceDetails = res)
    if (deviceDetails && deviceDetails.version && !environment.app) {
      data.deviceId = `${Date.now().toLocaleString().replace(/\,/g, '.')}${deviceDetails.version}`
    } else {
      data.deviceId = device.uuid
    }
    return this.http.post(API_END_POINTS.CLIENTS.events, data)
  }

  getAdvisorComplaint(id): Observable<any> {
    return this.http.get(`${API_END_POINTS.ADVISOR.client_complaints}/${id}`);
  }
  getClosedCalls() {
    return this.http.get(`${API_END_POINTS.CLIENTS.calls}`);
  }
  getMarketData(type) {
    return this.http.get(`${API_END_POINTS.CLIENTS.marketDetail}/${type}`);
  }
  getTopAdvisors() {
    return this.http.get(`${API_END_POINTS.CLIENTS.topAdvisors}`);
  }

  updateSip(id, data): Observable<any> {
    return this.http.put(`${API_END_POINTS.INVESTOR_LONGTERM.sip}/${id}`, data);
  }

  getReferralAmount(referActivities:any[]): Observable<any> {
    const activies = referActivities.join(',')
    return this.http.get(`${API_END_POINTS.WALLET.referral_amt}?scope=investor&activities=${activies}`)
  }

  getReferralDetails(): Observable<any>{
    return this.http.get(`${API_END_POINTS.WALLET.referral_credits}`)
  }

  allRewards(): Observable<any> {
    return this.http.get(`${API_END_POINTS.WALLET.rewards}`)
  }
}


@Injectable()
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}

function _window(): any {
  if(typeof window !== 'undefined'){
    return window;
  }
}
